import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { Route, Routes } from 'react-router';

import { keys, setUnauthorizedHandler, useSession } from './api';
import { Layout } from './components/Layout';
import { Spinner } from './components/ui';
import { Dashboard } from './pages/Dashboard';
import { DefinitionPage } from './pages/DefinitionPage';
import { Definitions } from './pages/Definitions';
import { InstanceDetail } from './pages/InstanceDetail';
import { InstanceNew } from './pages/InstanceNew';
import { Instances } from './pages/Instances';
import { Login } from './pages/Login';
import { Scenarios } from './pages/Scenarios';
import { SettingsPage } from './pages/Settings';

export function App() {
	const session = useSession();
	const qc = useQueryClient();
	useEffect(() => setUnauthorizedHandler(() => qc.invalidateQueries({ queryKey: keys.session })), [qc]);

	if (session.isPending) {
		return (
			<div className="grid min-h-dvh place-items-center">
				<Spinner />
			</div>
		);
	}
	if (session.data?.authRequired && !session.data.authenticated) return <Login />;
	return (
		<Layout>
			<Routes>
				<Route path="/" element={<Dashboard />} />
				<Route path="/instances" element={<Instances />} />
				<Route path="/instances/new" element={<InstanceNew />} />
				<Route path="/instances/:id" element={<InstanceDetail />} />
				<Route path="/definitions" element={<Definitions />} />
				<Route path="/definitions/:id" element={<DefinitionPage />} />
				<Route path="/scenarios" element={<Scenarios />} />
				<Route path="/settings" element={<SettingsPage />} />
				<Route path="*" element={<p className="text-fg-muted">Page not found.</p>} />
			</Routes>
		</Layout>
	);
}
